import { useDispatch } from "react-redux";
import { snackbarActions as actionTypes } from "../config/action-config";

export default function useSnackbar () {
    const dispatch = useDispatch();

    function showError (message = "File Doesn't Exist") {
        dispatch({ type: actionTypes.SHOW, severity: "error", message })
    }

    function showInfo (message = "Info") {
        dispatch({ type: actionTypes.SHOW, severity: "info", message })
    }

    function showSuccess (message = "Success") {
        dispatch({ type: actionTypes.SHOW, severity: "success", message })
    }

    function hide () {
        dispatch({ type: actionTypes.HIDE })
    }

    return { showError, showInfo, showSuccess, hide }
}